import React from 'react';
import { Box, Paper, Stack, Typography, Divider } from '@mui/material';
import { useTranslation } from 'src/text';
import { ExpenseForm } from './components/expense-form';
import { ExpenseList } from './components/expense-list';
import { SummaryCards } from './components/summary-cards';
import { AiControlHubNotice } from './components/ai-control-hub';
import { contentBox, listCard, listDivider } from './styles';

export const ExpenseTrackerContainer: React.FC = () => {
  const { expenseLabels } = useTranslation();

  return (
    <Box sx={contentBox}>
      <Typography variant="h5" fontWeight={700} mb={2}>
        {expenseLabels.title}
      </Typography>

      <AiControlHubNotice />

      <SummaryCards />

      <Paper elevation={0}>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          {expenseLabels.addExpenseTitle}
        </Typography>
        <ExpenseForm />
      </Paper>

      <Paper elevation={0} sx={listCard}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          mb={1}>
          <Typography variant="subtitle1" fontWeight={600}>
            {expenseLabels.recentExpensesTitle}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {expenseLabels.recentExpensesHelper}
          </Typography>
        </Stack>
        <Divider sx={listDivider} />
        <ExpenseList />
      </Paper>
    </Box>
  );
};
